<template>
  <div class="remote-desktop">
    <!-- 首屏 banner -->
    <div class="section-banner">
      <div class="banner-main">
        <div class="banner-row">
          <div class="banner-left">
            <div class="banner-title move">远程桌面</div>
            <div class="banner-subtitle move delay-100"">随时随地远程连接你的电脑</div>
            <div class="banner-desc move delay-200">
              通过节点小宝客户端远程访问并控制电脑。出门在外也能轻松操作家中、办公或云端主机；跨平台连接、高清流畅、操作便捷，数据传输端到端加密，安全可靠。
            </div>
            <div class="banner-btns">
              <div class="btn-primary" @click="goDownload">立即体验</div>
              <div class="btn-ghost" @click="goDoc">查看文档</div>
            </div>
          </div>
          <img class="banner-pic" :src="bannerPic" alt="" />
        </div>
        <div class="banner-features">
          <div class="feature-item">
            <img class="feature-icon" :src="featXplatform" alt="" />
            <div class="feature-text">
              <div class="feature-title">跨平台连接</div>
              <div class="feature-sub">Windows / macOS / iOS / Android</div>
            </div>
          </div>
          <div class="feature-item">
            <img class="feature-icon" :src="featHd" alt="" />
            <div class="feature-text">
              <div class="feature-title">高清流畅</div>
              <div class="feature-sub">低延迟操控，画面清晰顺滑</div>
            </div>
          </div>
          <div class="feature-item">
            <img class="feature-icon" :src="featSafe" alt="" />
            <div class="feature-text">
              <div class="feature-title">安全可靠</div>
              <div class="feature-sub">加密传输，访问可控</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 核心能力 -->
    <div class="section-adv">
      <div class="adv-main">
        <div class="section-title move">核心优势</div>
        <div class="section-sub move delay-100">轻松管理多节点网络</div>
        <div class="adv-grid">
          <div class="adv-card move" v-for="(item, index) in advList" :key="item.title" :style="{ transitionDelay: index * 0.1 + 's' }">
            <img class="adv-icon" :src="item.icon" alt="" />
            <div class="adv-title">{{ item.title }}</div>
            <div class="adv-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 工作原理 -->
    <div class="section-flow">
      <div class="flow-main">
        <div class="section-title move">工作原理</div>
        <div class="section-sub move delay-100">极致简单，安全访问</div>
        <div class="flow-grid">
          <template v-for="(item, index) in flowList">
            <div class="flow-card move" :key="item.title" :style="{ transitionDelay: index * 0.1 + 's' }">
              <div class="flow-top">
                <img :src="item.img" alt="" />
              </div>
              <div class="flow-title">{{ item.title }}</div>
              <div class="flow-desc">{{ item.desc }}</div>
            </div>
            <div v-if="index < flowList.length - 1" class="flow-arrow" :key="'arrow-' + index">
              <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
                <path d="M8 8l6 7-6 7" stroke="#3772ff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M16 8l6 7-6 7" stroke="#3772ff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- 支持平台（渐变底） -->
    <div class="section-platform">
      <div class="platform-main">
        <div class="section-title move">支持平台</div>
        <div class="platform-devices">
          <div class="device-item move" v-for="(item, index) in deviceList" :key="item.label" :style="{ transitionDelay: index * 0.1 + 's' }">
            <img :src="item.img" :style="{ width: item.w + 'px', height: item.h + 'px' }" alt="" />
            <div class="device-label">{{ item.label }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 应用场景 -->
    <div class="section-scene">
      <div class="scene-main">
        <div class="section-title move">应用场景</div>
        <div class="scene-grid">
          <div class="scene-card move" v-for="(item, index) in sceneList" :key="item.title" :style="{ transitionDelay: index * 0.1 + 's' }">
            <div class="scene-img-wrap">
              <img :src="item.img" alt="" />
            </div>
            <div class="scene-title">{{ item.title }}</div>
            <div class="scene-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 CTA -->
    <div class="section-cta">
      <img class="cta-overlay" :src="ctaOverlay" alt="" />
      <div class="cta-main">
        <div class="cta-title">开启你的远程桌面体验</div>
        <div class="cta-sub">一键连接远程电脑，跨平台访问，安全稳定，随时处理工作和个人事务</div>
        <div class="btn-primary cta-btn" @click="goDownload">免费体验</div>
      </div>
    </div>

    <Foot></Foot>
  </div>
</template>

<script>
import Foot from '@/components/Foot.vue'

export default {
  name: 'RemoteDesktop',
  components: {
    Foot,
  },
  data: function () {
    return {
      bannerPic: require('@/assets/remote_desktop/banner.webp'),
      featXplatform: require('@/assets/remote_desktop/feat_xplatform.png'),
      featHd: require('@/assets/remote_desktop/feat_hd.png'),
      featSafe: require('@/assets/remote_desktop/feat_safe.png'),
      ctaOverlay: require('@/assets/introduce/cta_bg.png'),
      advList: [
        {
          icon: require('@/assets/remote_desktop/adv_ctrl.png'),
          title: '远程控制',
          desc: '支持原创查看与操作桌面',
        },
        {
          icon: require('@/assets/remote_desktop/adv_multi.png'),
          title: '多端访问',
          desc: 'Windows/macOS/iOS /Android<br>客户端支持',
        },
        {
          icon: require('@/assets/remote_desktop/adv_file.png'),
          title: '文件传输',
          desc: '便捷传输文件',
        },
        {
          icon: require('@/assets/remote_desktop/adv_clipboard.png'),
          title: '剪贴板同步',
          desc: '复制粘贴更高效',
        },
        {
          icon: require('@/assets/remote_desktop/adv_safe.png'),
          title: '安全访问',
          desc: '设备授权，会话保护，数据加密',
        },
      ],
      flowList: [
        {
          img: require('@/assets/remote_desktop/flow1.png'),
          title: '绑定设备',
          desc: '将需要被控的电脑绑定到账号',
        },
        {
          img: require('@/assets/remote_desktop/flow2.png'),
          title: '发起连接',
          desc: '在客户端选择目标设备',
        },
        {
          img: require('@/assets/remote_desktop/flow3.png'),
          title: '安全验证',
          desc: '建立安全会话与访问校验',
        },
        {
          img: require('@/assets/remote_desktop/flow4.png'),
          title: '远程控制',
          desc: '查看桌面并进行鼠标键盘操作',
        },
      ],
      deviceList: [
        {
          img: require('@/assets/remote_desktop/dev_win.png'),
          label: 'Windows',
          w: 200,
          h: 200,
        },
        {
          img: require('@/assets/remote_desktop/dev_mac.png'),
          label: 'Mac',
          w: 200,
          h: 200,
        },
        {
          img: require('@/assets/remote_desktop/dev_phone.png'),
          label: '手机',
          w: 120,
          h: 200,
        },
        {
          img: require('@/assets/remote_desktop/dev_ipad.webp'),
          label: '平板电脑PAD',
          w: 160,
          h: 200,
        },
      ],
      sceneList: [
        {
          img: require('@/assets/remote_desktop/scene1.webp'),
          title: '远程办公',
          desc: '随时访问公司电脑，处理工作更加高效',
        },
        {
          img: require('@/assets/remote_desktop/scene2.webp'),
          title: '远程剪辑',
          desc: '无需下载素材文件，可随时访问电脑，无缝衔接',
        },
        {
          img: require('@/assets/remote_desktop/scene3.webp'),
          title: '文件传输',
          desc: '跨设备传输文件，提升工作效率',
        },
        {
          img: require('@/assets/remote_desktop/scene4.webp'),
          title: '远程运维',
          desc: '远程管理服务器与设备，稳定可靠',
        },
        {
          img: require('@/assets/remote_desktop/scene5.webp'),
          title: '远程协助',
          desc: '跨账号发起远程协助，为客户提供技术支持',
        },
      ],
    }
  },
  methods: {
    goDownload: function () {
      if (this.$route.path !== '/download') {
        this.$router.push('/download')
      }
    },
    goDoc: function () {
      window.open('https://iepose.com/helpcenter_v3/')
    },
    // 滚动检查：进入视口的 .move 元素加 move-active，触发入场动画（同首页模式）
    checkInView: function (animatedElements) {
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight
      animatedElements.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top
        const elementBottom = element.getBoundingClientRect().bottom
        const isInView = elementTop < windowHeight - 100 && elementBottom > 0
        if (isInView) {
          element.classList.add('move-active')
        }
      })
    },
  },
  mounted: function () {
    const animatedElements = document.querySelectorAll('.move')
    // 首屏元素立即检查一次（页面刚加载时尚未触发 scroll，避免首屏内容空白）
    this.$nextTick(() => {
      this.checkInView(animatedElements)
    })
    window.addEventListener('scroll', () => {
      this.checkInView(animatedElements)
    })
  },
}
</script>

<style scoped lang="less">
.remote-desktop {
  width: 100%;

  .section-title {
    font-size: 40px;
    font-weight: 700;
    color: #1d1f24;
    text-align: center;
  }

  .section-sub {
    margin-top: 12px;
    font-size: 24px;
    line-height: 36px;
    color: #777e90;
    text-align: center;
  }

  .btn-primary {
    width: 160px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #ffffff;
    font-size: 18px;
    border-radius: 8px;
    background: #3772ff;
    cursor: pointer;
  }

  .btn-primary:hover {
    opacity: 0.9;
  }

  /* ---------- 首屏 ---------- */
  .section-banner {
    padding-top: 122px;
    padding-bottom: 70px;
    // 横向渐变：左浅蓝 → 右淡蓝
    background: linear-gradient(90deg, #e5edff 0%, #dbecff 100%);

    .banner-main {
      width: 1280px;
      margin: 0 auto;
    }

    .banner-row {
      position: relative;
      height: 328px;

      .banner-pic {
        position: absolute;
        right: 0;
        top: -59px;
        width: 546px;
        height: 440px;
        flex-shrink: 0;
      }
    }

    .banner-left {
      width: 610px;
      flex-shrink: 0;
    }

    .banner-title {
      width: fit-content;
      font-size: 64px;
      font-weight: 700;
      line-height: 72px;
      background: linear-gradient(
        90deg,
        #3772ff 0%,
        #aa56ff 35%,
        #ff6838 70%,
        #ff9924 100%
      );
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .banner-subtitle {
      margin-top: 13px;
      font-size: 44px;
      font-weight: 700;
      line-height: 66px;
      color: #1d1f24;
    }

    .banner-desc {
      margin-top: 9px;
      width: 650px;
      font-size: 20px;
      line-height: 29px;
      color: #777e90;
    }

    .banner-btns {
      display: flex;
      margin-top: 33px;
    }

    .btn-ghost {
      margin-left: 16px;
      width: 160px;
      height: 48px;
      line-height: 46px;
      text-align: center;
      font-size: 18px;
      color: #3772ff;
      border: 1px solid #3772ff;
      border-radius: 8px;
      box-sizing: border-box;
      cursor: pointer;
    }

    .btn-ghost:hover {
      background: rgba(55, 114, 255, 0.08);
    }

    .banner-features {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 80px;
      height: 120px;
      padding: 0 67px;
      background: rgba(255, 255, 255, 0.4);
      border: 1px solid rgba(255, 255, 255, 0.5);
      border-radius: 20px;
      box-sizing: border-box;
      // 毛玻璃悬浮条：半透明白 + 背景模糊
      -webkit-backdrop-filter: blur(10px);
      backdrop-filter: blur(10px);
      box-shadow: 0 8px 24px rgba(23, 33, 94, 0.06);
    }

    .feature-item {
      display: flex;
      align-items: center;

      .feature-icon {
        width: 60px;
        height: 60px;
      }

      .feature-text {
        margin-left: 12px;

        .feature-title {
          font-size: 24px;
          font-weight: 700;
          line-height: 36px;
          color: #1d1f24;
        }

        .feature-sub {
          margin-top: 2px;
          font-size: 16px;
          line-height: 24px;
          color: #777e90;
        }
      }
    }
  }

  /* ---------- 核心能力 ---------- */
  .section-adv {
    padding-top: 60px;
    padding-bottom: 82px;
    background: #ffffff;
    box-sizing: border-box;

    .adv-main {
      width: 1280px;
      margin: 0 auto;
    }

    .adv-grid {
      display: flex;
      justify-content: space-between;
      margin-top: 50px;
    }

    .adv-card {
      width: 240px;
      min-height: 220px;
      padding: 33px 24px 0;
      background: #f7f9fe;
      border-radius: 16px;
      box-sizing: border-box;

      .adv-icon {
        width: 48px;
        height: 48px;
        display: block;
      }

      .adv-title {
        margin-top: 24px;
        font-size: 24px;
        font-weight: 700;
        line-height: 36px;
        color: #1d1f24;
      }

      .adv-desc {
        margin-top: 10px;
        font-size: 14px;
        line-height: 21px;
        color: #777e90;
      }
    }
  }

  /* ---------- 工作原理 ---------- */
  .section-flow {
    padding-top: 60px;
    padding-bottom: 82px;
    background: #f7f9fe;
    box-sizing: border-box;

    .flow-main {
      width: 1280px;
      margin: 0 auto;
    }

    .flow-grid {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 50px;
    }

    .flow-card {
      width: 302px;
      padding: 30px 30px 0;
      // 卡片固定 300 高，文案行数不同也能等高
      min-height: 300px;
      background: #ffffff;
      border-radius: 20px;
      box-shadow: 0 4px 30px 0 rgba(55, 114, 255, 0.05);
      box-sizing: border-box;

      .flow-top {
        height: 140px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;

        img {
          width: 160px;
          height: 140px;
          object-fit: contain;
        }
      }

      .flow-title {
        margin-top: 20px;
        font-size: 24px;
        font-weight: 700;
        line-height: 34px;
        color: #1d1f24;
        text-align: center;
      }

      .flow-desc {
        // 底部留白 14px：两行文案时内容 286，配合 min-height 300 全卡等高；40px 会把卡顶超
        margin: 10px auto 14px;
        font-size: 16px;
        line-height: 26px;
        color: #777e90;
        text-align: center;
      }
    }

    .flow-arrow {
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
  }

  /* ---------- 支持平台（渐变底） ---------- */
  .section-platform {
    padding-top: 87px;
    padding-bottom: 126px;
    background: linear-gradient(
      90deg,
      #ecf0ff 0%,
      #f1efff 20%,
      #f8eefc 42%,
      #fef0ec 68%,
      #fff2ea 83%,
      #fff4e9 100%
    );
    box-sizing: border-box;

    .platform-main {
      width: 1280px;
      margin: 0 auto;
    }

    .platform-title {
      font-size: 40px;
      font-weight: 700;
      color: #1d1f24;
      text-align: center;
    }

    .platform-devices {
      display: flex;
      justify-content: center;
      align-items: flex-end;
      margin-top: 71px;
    }

    .device-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 58px;

      img {
        display: block;
      }

      .device-label {
        margin-top: 20px;
        font-size: 24px;
        font-weight: 700;
        line-height: 36px;
        color: #1d1f24;
        text-align: center;
      }
    }

    .device-item:nth-child(3) {
      margin-right: 75px;
    }

    .device-item:last-child {
      margin-right: 0;
    }
  }

  /* ---------- 应用场景 ---------- */
  .section-scene {
    padding-top: 60px;
    padding-bottom: 82px;
    background: #ffffff;
    box-sizing: border-box;

    .scene-main {
      width: 1280px;
      margin: 0 auto;
    }

    .scene-grid {
      display: flex;
      justify-content: space-between;
      margin-top: 50px;
    }

    .scene-card {
      width: 240px;
      background: #ffffff;
      box-sizing: border-box;

      .scene-img-wrap {
        height: 180px;
        border-radius: 20px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          }
      }

      .scene-title {
        margin-top: 19px;
        // 文本左右 12px
        padding: 0 12px;
        font-size: 24px;
        font-weight: 700;
        line-height: 36px;
        color: #1d1f24;
      }

      .scene-desc {
        margin-top: 13px;
        // 文本左右 12px
        padding: 0 12px;
        font-size: 14px;
        line-height: 21px;
        color: #777e90;
      }
    }
  }

  /* ---------- 底部 CTA ---------- */
  .section-cta {
    position: relative;
    padding-top: 67px;
    padding-bottom: 60px;
    background: #3772ff;
    overflow: hidden;
    box-sizing: border-box;

    .cta-overlay {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      mix-blend-mode: overlay;
      opacity: 0.6;
      pointer-events: none;
    }

    .cta-main {
      position: relative;
      width: 1280px;
      margin: 0 auto;
      text-align: center;
    }

    .cta-title {
      font-size: 40px;
      font-weight: 700;
      line-height: 60px;
      color: #ffffff;
    }

    .cta-sub {
      margin-top: 12px;
      font-size: 18px;
      color: #ffffff;
    }

    .cta-btn {
      margin: 26px auto 0;
      width: 168px;
      height: 48px;
      line-height: 48px;
      font-size: 19px;
      background: #ffffff;
      color: #3772ff;
    }
  }

  /* ---------- 滚动入场动画（同首页模式） ---------- */
  .move {
    opacity: 0;
    transform: translateY(50px);
    transition: opacity 0.8s ease-out, transform 0.8s ease-out;
  }
  .move-active {
    opacity: 1;
    transform: translateY(0);
  }
  /* 为不同元素设置不同的延迟，创建层次感 */
  .delay-100 {
    transition-delay: 0.1s;
  }
  .delay-200 {
    transition-delay: 0.2s;
  }
  .delay-300 {
    transition-delay: 0.3s;
  }
}
</style>
